// ==============================|| OVERRIDES - TAB ||============================== //

export default function Tab() {
  return {
    MuiTab: {}
  };
}
